import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { TransportWithPicking } from "interfaces/transport";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_PANEL_" }
);

export interface PaginatePanelState extends IState {
  data: TransportWithPicking[];
}

const INITIAL_STATE: PaginatePanelState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginatePanelState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginatePanelState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data as TransportWithPicking[] },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginatePanelState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginatePanel = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginatePanelTypes = Types;
export const PaginatePanelActions = Creators;
